<script setup lang="ts">
defineProps({
  modelValue: Boolean,
  modalId: {
    type: String,
    required: false,
    default: "",
  },
  title: String,
  titleTheme: {
    type: String,
    default: "dark", // 可選值: 'dark', 'light'
  },
  showCancel: Boolean,
  showConfirm: Boolean,
  showRefresh: Boolean,
  showDelete: Boolean,
  customButton: {
    type: Object as () => {
      text?: string;
      class?: string;
    } | null,
    default: null,
  },
  confirmClass: {
    type: String,
    default: "bg-pr",
  },
  cancelClass: {
    type: String,
    default: "bg-black-3",
  },
  refreshClass: {
    type: String,
    default: "bg-pr",
  },
  deleteClass: {
    type: String,
    default: "bg-dark",
  },
});

const emit = defineEmits([
  "update:modelValue",
  "confirm",
  "cancel",
  "refresh",
  "delete",
  "custom",
]);

function close() {
  emit("update:modelValue", false);
}
</script>

<template>
  <div
    :id="modalId"
    class="modal fixed p-center"
    :style="[modelValue ? 'display: block' : 'display: none']"
  >
    <div
      class="modalTitle title-2 flex j-between white-1"
      :class="titleTheme === 'dark' ? 'bg-dark' : 'bg-pr'"
    >
      {{ title }}
      <div class="icon-close pointer white-1" @click="close"></div>
    </div>

    <div class="modalContent bg-white-1 scroll">
      <slot />
    </div>

    <div class="modalFooter bg-white-1">
      <div class="t-right flex gap-5 j-end">
        <button
          v-if="customButton"
          class="btn-sm"
          :class="customButton.class || 'bg-black-3'"
          @click="
            $emit('custom');
            close();
          "
        >
          {{ customButton.text || "Custom" }}
        </button>

        <button
          v-if="showCancel"
          class="btn-sm"
          :class="cancelClass"
          @click="
            $emit('cancel');
            close();
          "
        >
          Cancel
        </button>

        <button
          v-if="showRefresh"
          class="btn-sm"
          :class="refreshClass"
          @click="
            $emit('refresh');
            close();
          "
        >
          Refresh
        </button>

        <button
          v-if="showConfirm"
          class="btn-sm"
          :class="confirmClass"
          @click="
            $emit('confirm');
            close();
          "
        >
          Confirm
        </button>

        <button
          v-if="showDelete"
          class="btn-sm"
          :class="deleteClass"
          @click="
            $emit('delete');
            close();
          "
        >
          Delete
        </button>
      </div>
    </div>
  </div>

  <div v-if="modelValue" class="mask fixed active"></div>
</template>

<style scoped>
@import "../assets/css_lib/themimir.css";
</style>
